import Promise from 'bluebird';
import _ from 'underscore';
import $ from 'jquery';
import { stringifySync } from '@bingads-webui/safe-json';

const adStrengthSuggestionEndpoint = '{odataPath}AdInsight/V2/Customers({customer_id})/Accounts({account_id})/Campaigns({campaign_id})/AdGroups({adgroup_id})/RSAV2.GetRSAV2AssetsSuggestions';

const formatUrl = (url, odataPath, appState, campaignId, adGroupId, accountId = 0) => url
  .replace('{odataPath}', odataPath)
  .replace('{account_id}', !_.isUndefined(appState.get('account_id')) ? appState.get('account_id') : accountId)
  .replace('{customer_id}', appState.get('customer_id'))
  .replace('{campaign_id}', campaignId)
  .replace('{adgroup_id}', adGroupId);

export class AdStrengthSuggestionRepository {
  constructor({
    viewModel,
    appState,
    token,
    odataPath,
  }) {
    this.viewModel = viewModel;
    this.appState = appState;
    this.token = token;
    this.odataPath = odataPath;
  }

  fetchAdStrengthSuggestion() {
    const {
      viewModel,
      appState,
      token,
      odataPath,
    } = this;

    let currentFinalUrl = null;
    if (!_.isEmpty(this.viewModel.FinalUrls()) && !_.isUndefined(this.viewModel.FinalUrls()) && !_.isEmpty(_.first(this.viewModel.FinalUrls()))) {
      currentFinalUrl = _.first(this.viewModel.FinalUrls());
    } else {
      return Promise.resolve({ data: [] });
    }

    const requestBody = {
      finalUrl: currentFinalUrl,
    };

    const option = {
      url: formatUrl(
        adStrengthSuggestionEndpoint,
        odataPath,
        appState,
        viewModel.scope().campaignId,
        viewModel.scope().adGroupId,
        viewModel.accountId
      ),
      contentType: 'application/json',
      headers: {
        authorization: `CCMTSmallToken ${token}`,
      },
      type: 'POST',
      data: stringifySync(requestBody),
    };

    const fetchDataPromise = new Promise((resolve, reject) => {
      $.ajax(option).then((rawData) => {
        resolve(rawData);
      }, reject);
    });

    return fetchDataPromise.then(rawData => ({
      data: rawData,
    }));
  }
}
